// client/src/modules/fieldService/index.ts
import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

/**
 * Field Service module manifest (P11)
 *
 * Service tickets, scheduling, generators, contracts, and FSR reports.
 * Includes merged Contracts (formerly P3) as a sub-section.
 */
export const fieldServiceModule: ModuleManifest = {
  id: 'P11',
  name: 'Field Service',
  shortName: 'Field Service',
  description: 'Service tickets, scheduling, generators, contracts, and field service reports',
  icon: '\uD83D\uDD27',
  status: 'live',
  urlPrefix: '/field-service',
  routes,
  navItems,
  collections: {
    APPSHEET_SERVICE_LOGS: 'appsheet_service_logs',
    APPSHEET_SCHEDULE_BLOCKS: 'appsheet_schedule_blocks',
    APPSHEET_SERVICE_PARTS: 'appsheet_service_parts',
    APPSHEET_SERVICE_FILES: 'appsheet_service_files',
    APPSHEET_GENERATORS: 'appsheet_generators',
    APPSHEET_RECURRING_SCHEDULES: 'appsheet_recurring_schedules',
  },
};

export default fieldServiceModule;
